import { addListener } from "@grindex-common/helpers/domManipulation";

function init($views) {
	$views.forEach(($hotspotImageView) => {
		$hotspotImageView.querySelectorAll(".hotspot").forEach(($hotspot) => {
			addListener($hotspot, "click", function (e) {
				hotspotClicked(e);
			});
		});

		$hotspotImageView.querySelectorAll(".mobile-tab-header").forEach(($mobiletabheader) => {
			addListener($mobiletabheader, "click", function (e) {
				const $currentTab = $(e.currentTarget);
				$currentTab.toggleClass("selected");
				$currentTab.next(".tab-content").toggle();
			});
		});
	});

	function hotspotClicked(event) {
		const $hotspot = $(event.currentTarget);
		const url = $hotspot.find(".tooltip_content a").prop("href");
		window.location = url;
	}
}

export default {
	view: "hotspotImage",
	init,
};
